import React from 'react';

import PropTypes from 'prop-types';

import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import CircularProgress from '@material-ui/core/CircularProgress';
import MyLocationIcon from '@material-ui/icons/MyLocation';

import createLocationMarker from './LocationMarker';

const LOCATOR_STATE = Object.freeze({
  ON: Symbol('on'),
  LOADING: Symbol('loading'),
  ERROR: Symbol('error'),
  OFF: Symbol('off'),
});

class CurrentLocationButton extends React.Component {

  state = {
    locatorState: LOCATOR_STATE.OFF,
  };

  locationMarker = null;

  onClick = () => {
    const { locatorState } = this.state;

    if (locatorState === LOCATOR_STATE.ON) {
      this.panToLocationMarker();
    } else if (locatorState === LOCATOR_STATE.OFF || locatorState === LOCATOR_STATE.ERROR) {
      this.setState({ locatorState: LOCATOR_STATE.LOADING });

      navigator.geolocation.watchPosition(
        this.onPositionUpdate,
        this.onPositionError,
        { enableHighAccuracy: true },
      );
    }
  }

  panToLocationMarker = () => {
    const { map } = this.props;

    if (this.locationMarker) {
      map.panTo(this.locationMarker.position);
    }
  }

  onPositionUpdate = (position) => {
    const { map } = this.props;
    const { locatorState } = this.state;

    const pos = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    };

    if (!this.locationMarker) {
      this.locationMarker = createLocationMarker({
        position: pos,
        accuracy: 100,
        map,
      });
    }

    this.locationMarker.updatePosition(pos);

    if (locatorState === LOCATOR_STATE.LOADING) {
      this.panToLocationMarker();
      this.setState({ locatorState: LOCATOR_STATE.ON });
    }
  }

  onPositionError = () => {
    this.setState({ locatorState: LOCATOR_STATE.ERROR });
  }

  render() {
    const { locatorState } = this.state;

    let icon;
    switch (locatorState) {
      case LOCATOR_STATE.LOADING:
        icon = <CircularProgress color="inherit" size={22}/>;
        break;
      case LOCATOR_STATE.ERROR:
        icon = <WarningRoundedIcon style={{ color: '#cd3d64' }} />;
        break;
      default:
        icon = <MyLocationIcon />;
    }

    return (
      <button
        id="showCurrentLocationBtn"
        className="map-btn-new"
        onClick={this.onClick}
        disabled={locatorState === LOCATOR_STATE.LOADING}
      >
        {icon}
      </button>
    );
  }
}

CurrentLocationButton.propTypes = {
  map: PropTypes.object,
};

export default CurrentLocationButton;
